module.exports = "../../app/cells/pages/guides_list/cta_guides_list_cell.rb";